const DepartmentPreviewModal = ({department, fancy = false, linkContent}) => {
    if (!department) {
        return <i>Select a department</i>;
    }

    const className = department.className;

    return (
        <span className={`dept-${className}`} style={{marginRight: '5px'}}>
            {linkContent}
        </span>
    );
}

export default DepartmentPreviewModal;
